<template>
  <div class="preferences__page">
    <h1>Preferences</h1>
    <v-row v-if="isLoading">
      <v-col cols="12" md="4">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
      <v-col cols="12" md="8">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
      <v-col cols="12" md="4">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
      <v-col cols="12" md="8">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
      <v-col cols="12" md="4">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
      <v-col cols="12" md="8">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
      <v-col cols="12" md="4">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
      <v-col cols="12" md="8">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
    </v-row>
    <div v-else>
      <Favicon />
      <v-divider class="my-5"></v-divider>
      <Logo />
      <v-divider class="my-5"></v-divider>
      <MetaDescription />
      <v-divider class="my-5"></v-divider>
      <Scripts />
      <v-divider class="my-5"></v-divider>
      <v-row>
        <v-col cols="12" md="4">
          <h3>Topbar</h3>
        </v-col>
        <v-col cols="12" md="8">
          <v-card class="pa-3" flat>
            <v-checkbox v-model="isShowTopBar" class="mt-0" label="Show TopBar"></v-checkbox>
            <label class="label-form">Content</label>
            <v-text-field
              placeholder="Enter contain for topbar"
              autocomplete="off"
              v-model.trim="attributes.topbarText"
              hide-details
            />
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-divider class="my-4"></v-divider>
        </v-col>
        <v-col cols="12" md="4"><h3>Prices</h3></v-col>
        <v-col cols="12" md="8">
          <v-checkbox v-model="isShowPriceSaving" class="mt-0" label="Show price savings" hide-details=""></v-checkbox>
        </v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <HomePageImages :themeSetting="themeSetting" @change="onChangeHomePageImages" />
      <v-divider class="my-4"></v-divider>
      <v-row>
        <v-col cols="12"> </v-col>
        <v-col cols="12" md="4"><h3>Footer</h3></v-col>
        <v-col cols="12" md="8">
          <label class="form-label">Address</label>
          <v-textarea
            v-model="storeAddress"
            background-color="white"
            dense
            placeholder="Address info"
            :rules="[v => !!v || 'Address is required!']"
          ></v-textarea>
        </v-col>
      </v-row>
      <!-- <Criteo />
      <v-divider class="my-5"></v-divider>
      <GoogleAnalytic />
      <v-divider class="my-5"></v-divider>
      <GoogleAdsTracking
        :data="{
          googleAdsConversionTrack: attributes.googleAdsConversionTrack,
          googleAdsConversionLabel: attributes.googleAdsConversionLabel,
        }"
        ref="google-ads-tracking"
      />
      <v-divider class="my-5"></v-divider>
      <FacebookPixel @removePixel="removePixel" @addPixel="addPixel" :facebookPixel="facebookPixel" />
      <v-divider class="my-5"></v-divider>
      <TiktokIdPixel @removeTikTokPixel="removeTikTokPixel" @addTikTokPixel="addTikTokPixel" :tiktok="tiktok" />
      <v-divider class="my-5"></v-divider>
      <PinterestBing />
      <v-divider class="my-5"></v-divider>
      <Klaviyo />
      <v-divider class="my-5"></v-divider>
      <PasswordProtection />
      <v-divider class="my-5"></v-divider>
      <PersonalizationPreview />
      <v-divider class="my-5"></v-divider> -->

      <div class="text-end">
        <v-btn :disabled="checkEmptyId()" :loading="isLoadingAction" color="primary" depressed @click="submit"
          >Save changes</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
// import Criteo from './components/CriteoOneTag';
// import GoogleAnalytic from './components/GoogleAnalytic';
// import GoogleAdsTracking from './components/GoogleAdsTracking';
// import FacebookPixel from './components/FacebookPixel';
// import TiktokIdPixel from './components/TiktokIdPixel';
// import Klaviyo from './components/Klaviyo';
// import PinterestBing from './components/PinterestBing';
// import PinterestBing from './components/PinterestBing';
// import PasswordProtection from './components/PasswordProtection';
// import PersonalizationPreview from './components/PersonalizationPreview';
import Favicon from './components/Favicon';
import MetaDescription from './components/MetaDescription';
import Scripts from './components/Scripts';
import Logo from './components/Logo.vue';
import HomePageImages from './components/HomePageImages.vue';
import event from '@/plugins/event-bus';
import { preferencesApi } from '@/apis/preferences';
import { required, minLength, maxLength, between, email } from 'vuelidate/lib/validators';
import { settingsApi } from '@/apis/settings';
import { domainService } from '@/apis/domain.s';
import { uploadService } from '../../../apis/upload.s';
import axios from 'axios';

export default {
  components: {
    Favicon,
    MetaDescription,
    Scripts,
    Logo,
    HomePageImages,
    // Criteo,
    // GoogleAnalytic,
    // GoogleAdsTracking,
    // FacebookPixel,
    // TiktokIdPixel,
    // Klaviyo,
    // PinterestBing,
    // PasswordProtection,
    // PersonalizationPreview,
  },
  validations: {
    attributes: {
      favIcon: {},
      homePageTitle: {
        maxLength: maxLength(70),
      },
      homePageDescription: {
        maxLength: maxLength(320),
      },
      googleAnalyticsIds: {},
      googleAdsConversionTrack: {},
      facebookPixel: {},
      criteo: {},
      klaviyoApiKey: {},
      addionalScriptHead: {},
      addionalScriptBody: {},
      passwordProtectedEnable: {},
      passwordProtected: {
        maxLength: maxLength(320),
      },
      personalizePreview: {},
      personalizePreviewOption: {},
    },
  },
  data() {
    return {
      loadingData: false,
      attributes: {
        image: '',
        criteo: {
          id: '',
        },
        topbarText: null,
        headerImages: [],
      },
      klaviyoListAndSegment: [],
      klaviyoListAndSegmentSms: [],
      // listSegment: [],
      facebookPixel: [
        {
          id: '',
          token: '',
        },
      ],
      tiktok: [{ pixel_id: '' }],
      mode: '',
      image: {
        src: '',
        position: 1,
      },
      logoOption: 'upload',
      outputImage: '',
      logoImage: {
        src: '',
        position: 1,
      },
      isLoading: false,
      isLoadingAction: false,
      general: {
        storeDetail: {
          name: '',
          accountEmail: '',
          customerEmail: '',
          telegramGroupIds: '',
        },
        language: 'en',
        addressLegalName: '',
        addressPhone: '',
        address: '',
        addressAppartment: '',
        addressCity: '',
        addressCountry: '',
        addressPostalCode: '',
        standardTimezone: '',
        standardUnitWeight: '',
        standardDefaultWeightUnit: '',
        editOrderIdPrfeix: '',
        editOrderIdSuffix: '',
        currency: '',
        currencyFormatHtmlWithoutCurrency: '',
        currencyEmailWithoutCurrency: '',
        blacklistStates: [],
      },
      isShowTopBar: true,
      isShowPriceSaving: true,
      storeAddress: null,
      themeSetting: null,
    };
  },
  created() {
    this.loadPreferences();
    this.loadGeneralSettings();
    this.getThemeSettings();
  },
  methods: {
    checkEmptyId() {
      let check;
      this.facebookPixel.forEach(i => {
        if (i.id === '') {
          check = true;
        } else {
          check = false;
        }
      });
      return check;
    },
    removePixel(index) {
      this.facebookPixel.splice(index, 1);
    },
    addPixel() {
      this.facebookPixel.push({
        id: '',
        token: '',
      });
    },
    removeTikTokPixel(index) {
      this.tiktok.splice(index, 1);
    },
    addTikTokPixel() {
      this.tiktok.push({
        pixel_id: '',
      });
    },
    getImageUpLoad(images) {},
    async loadPreferences() {
      this.isLoading = true;
      try {
        this.loadingData = false;
        let data = await preferencesApi.get();
        this.attributes = data.data;
        this.loadingData = true;
        this.facebookPixel = this.attributes.facebookPixel || [];
        this.tiktok = this.attributes.tiktok || [];
        if (this.attributes.favIcon) {
          this.image.src = this.attributes.favIcon;
        }
        if (this.attributes?.logoPath) {
          this.logoImage.src = this.attributes.logoPath;
        }
        if (this.attributes.personalizePreviewOption) {
          this.mode = this.attributes.personalizePreviewOption;
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    async submit() {
      this.attributes.facebookPixel = this.facebookPixel.map(x => x);
      this.attributes.tiktok = this.tiktok.map(x => x);
      this.attributes.personalizePreviewOption = this.mode;
      let googleAdsTracking = this.$refs['google-ads-tracking'];
      if (googleAdsTracking) {
        let conversion = googleAdsTracking.conversion;
        this.attributes.googleAdsConversionTrack = conversion.map(c => c.googleAdsConversionTrack).join(',');
        this.attributes.googleAdsConversionLabel = conversion.map(c => c.googleAdsConversionLabel).join(',');
      }
      this.isLoadingAction = true;
      try {
        // check image
        if (this.logoOption === 'default' && this.outputImage) {
          this.attributes.logoPath = this.outputImage;
          const blob = await fetch(this.outputImage).then(res => res.blob());
          const file = new File([blob], `logo-${Date.now()}.png`, { type: 'image/png' });
          let urlData = await uploadService.get({ filename: `image-${Date.now()}.png` });
          if (urlData) {
            let res = await axios.put(urlData.data.presignedUrl, file, {
              headers: {
                'Content-Type': `${file.type}`,
              },
            });
            this.attributes.logoPath = urlData.data.imagePath;
          }
        }

        await preferencesApi.update({
          ...this.attributes,
          topbarText: !this.isShowTopBar ? '' : this.attributes.topbarText,
          show_price_saving: this.isShowPriceSaving,
          storeAddress: this.storeAddress,
        });
        event.$emit('getStepStatus', message => {
          this.getStep();
        });
        await settingsApi.updateGeneral(this.general);
        this.$store.commit('setMessages', {
          messages: 'Success',
          type: 'success',
        });
      } catch (error) {
        console.log('🚀 ~ submit ~ error:', error);
        this.$store.commit('setMessages', {
          messages: 'Error',
          type: 'error',
        });
      } finally {
        this.isLoadingAction = false;
      }
    },
    async loadGeneralSettings() {
      try {
        const { data } = await settingsApi.getGeneral();
        this.general = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getThemeSettings() {
      try {
        const { data } = await domainService.checkEnableRef();
        if (data.length && data[0]) {
          const themeSettings = data[0];
          const currentValue = themeSettings?.pages?.fixed?.header?.block?.find(item => item?.component === 'top-bar')
            ?.config[1]?.value;
          const isShowTopBar = themeSettings?.pages?.fixed?.header?.block?.find(item => item?.component === 'top-bar')
            ?.config[0]?.value;
          this.isShowPriceSaving = !!themeSettings?.settings?.product?.layout?.show_price_saving;
          this.storeAddress = themeSettings?.pages?.fixed?.footer?.block[0]?.config?.find(
            item => item.label === 'Address',
          )?.value;
          this.isShowTopBar = !!isShowTopBar;
          this.attributes.topbarText = currentValue;
          this.themeSetting = themeSettings;
        }
      } catch (error) {
        console.log('🚀 ~ file: HomePageImages.vue:28 ~ getImages ~ error:', error);
      }
    },
    onChangeHomePageImages(images) {
      this.attributes.headerImages = images.filter(item => !!item);
    },
  },
};
</script>
